export default __webpack_public_path__ + "static/blogThumbnail(7)-79ba62a9279b687f1ef16b0a6ae79a8d.png";